import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LabelsPipe } from '../../shared/pipes/labels/labels.pipe';
import { PalantirAvatarComponent } from '../avatar/avatar.component';
import { PalantirAvatarGroupComponent } from '../avatar-group/avatar-group.component';
import { PalantirIconComponent } from '../icon/icon.component';
import { PalantirTextComponent } from '../text/text.component';
import { PalantirEntityChangeLogItemComponent } from './components/entity-change-log-item.component';
import type { PalantirEntityChangeLog } from './entity-change-logs.type';

@Component({
  selector: 'palantir-entity-change-logs',
  templateUrl: './entity-change-logs.component.html',
  styleUrls: ['./entity-change-logs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PalantirAvatarComponent,
    PalantirAvatarGroupComponent,
    PalantirIconComponent,
    PalantirTextComponent,
    PalantirEntityChangeLogItemComponent,
    LabelsPipe,
  ],
})
export class PalantirEntityChangeLogsComponent {
  public logs = input.required<PalantirEntityChangeLog[]>();
}
